import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { formatCurrency } from "../../../utils/formatCurrency";

type PaymentsHeaderProps = {
    paymentsTotal: number;
    orderTotal: number;
    onAddPayment?: () => void;
    showAddButton?: boolean;
};

export const PaymentsHeader = ({ paymentsTotal, orderTotal, onAddPayment, showAddButton }: PaymentsHeaderProps) => {
    const totalMatches = Math.abs(paymentsTotal - orderTotal) < 0.01;
    const totalColor = totalMatches ? "success.main" : "error.main";

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" pt={2} pb={3}>
            <Box>
                <Typography variant="h5">Pagamentos:</Typography>
                <Typography variant="h6" sx={{ color: totalColor, mt: 1 }}>
                    Total: {formatCurrency(paymentsTotal)}
                </Typography>
            </Box>
            {showAddButton && onAddPayment && (
                <Button variant="contained" startIcon={<AddIcon />} onClick={onAddPayment}>
                    Adicionar pagamento
                </Button>
            )}
        </Box>
    );
};

